(function () {
    'use strict';

    angular.module('ngtimeago', []);


    angular.module('ngtimeago').filter('timeago', function () {
        return function (input, p_allowFuture) {

            var substitute = function (stringOrFunction, number, strings) {
                var string = angular.isFunction(stringOrFunction) ? stringOrFunction(number, dateDifference) : stringOrFunction;
                var value = (strings.numbers && strings.numbers[number]) || number;
                return string.replace(/%d/i, value);
            },
                nowTime = (new Date()).getTime(),
                date = (new Date(input)).getTime(),
                //refreshMillis= 6e4, //A minute
                allowFuture = p_allowFuture || false,
                strings = {
                    prefixAgo: '',
                    prefixFromNow: '',
                    suffixAgo: window.lang === 'en' ? "ago" : "önce",
                    suffixFromNow: window.lang === 'en' ? "from now" : "sonra",
                    seconds: window.lang === 'en' ? "less then a minute" : "bir dakikadan az",
                    minute: window.lang === 'en' ? "a minute" : "bir dakika",
                    minutes: window.lang === 'en' ? "%d minutes" : "%d dakika",
                    hour: window.lang === 'en' ? "an hour" : "bir saat",
                    hours: window.lang === 'en' ? "%d hours" : "%d saat",
                    day: window.lang === 'en' ? "a day" : "1 gün",
                    days: window.lang === 'en' ? "%d days" : "%d gün",
                    month: window.lang === 'en' ? "a month" : "1 ay",
                    months: window.lang === 'en' ? "%d months" : "%d ay",
                    year: window.lang === 'en' ? "a year" : "1 yıl",
                    years: window.lang === 'en' ? "%d years" : "%d yıl"
                },
                dateDifference = nowTime - date,
                words,
                seconds = Math.abs(dateDifference) / 1000,
                minutes = seconds / 60,
                hours = minutes / 60,
                days = hours / 24,
                years = days / 365,
                separator = strings.wordSeparator === undefined ? " " : strings.wordSeparator,


                prefix = strings.prefixAgo,
                suffix = strings.suffixAgo;

            if (allowFuture) {
                if (dateDifference < 0) {
                    prefix = strings.prefixFromNow;
                    suffix = strings.suffixFromNow;
                }
            }

            words = seconds < 45 && substitute(strings.seconds, Math.round(seconds), strings) ||
                seconds < 90 && substitute(strings.minute, 1, strings) ||
                minutes < 45 && substitute(strings.minutes, Math.round(minutes), strings) ||
                minutes < 90 && substitute(strings.hour, 1, strings) ||
                hours < 24 && substitute(strings.hours, Math.round(hours), strings) ||
                hours < 42 && substitute(strings.day, 1, strings) ||
                days < 30 && substitute(strings.days, Math.round(days), strings) ||
                days < 45 && substitute(strings.month, 1, strings) ||
                days < 365 && substitute(strings.months, Math.round(days / 30), strings) ||
                years < 1.5 && substitute(strings.year, 1, strings) ||
                substitute(strings.years, Math.round(years), strings);
            prefix.replace(/ /g, '');
            words.replace(/ /g, '');
            suffix.replace(/ /g, '');
            return (prefix + ' ' + words + ' ' + suffix + ' ' + separator);

        };
    });

})();

